'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { ChevronsRight } from 'lucide-react';
import { HubMapNewsItem } from '@/types/hubs';
import IconAdaptive from '@/components/IconAdaptive';
import RectButton from '@/components/RectButton';
import SectionDecoratedTitle from '@/components/SectionDecoratedTitle';
import ProjectStoryUnit from '@/(routers)/top/components/unit/ProjectStoryUnit';

export interface TopProjectStoryProps {
    projectStories: HubMapNewsItem[];
}

export default function TopProjectStory({ projectStories }: TopProjectStoryProps) {
    const router = useRouter();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const visibleProjectStories = projectStories.slice(0, isMobile ? 3 : 9);
    const goToCases = () => {
        router.push('/hubs/cases');
    };

    return (
        <div className="flex flex-col justify-center items-center w-full pt-8 px-0 md:px-8">
            <div className="flex justify-center items-start w-full md:w-[98%] rounded-none md:rounded-3xl bg-color-white-base pt-8 px-8 pb-16">
                <div className="w-full md:w-[98%] lg:w-[85%] rounded-3xl">
                    <div className="flex w-full justify-start relative">
                        <div className="w-full pb-12">
                            <SectionDecoratedTitle title="PROJECT STORY" subTitle="スクーミーの事例を紹介" />
                        </div>
                        <div
                            className="absolute right-0 top-6 md:flex flex-grow justify-end items-center font-notojp font-bold text-color-base text-sm lg:text-base cursor-pointer hidden md:block"
                            onClick={goToCases}
                        >
                            <IconAdaptive
                                Icon={ChevronsRight}
                                baseSize={22}
                                breakpoints={{ md: 24 }}
                                className="mt-[2px]"
                            />
                            もっとみる
                        </div>
                    </div>
                    {visibleProjectStories.length > 0 && (
                        <>
                            <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-8 md:gap-4">
                                {visibleProjectStories.map((projectStory, index) => (
                                    <div className="flex w-full" key={index}>
                                        <ProjectStoryUnit projectStory={projectStory} />
                                    </div>
                                ))}
                            </div>
                            <div className="flex justify-center w-full py-8 md:hidden">
                                <RectButton label={'もっとみる'} width={'80%'} onClick={goToCases} />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
